import { useEffect, useRef, useState } from "react";

const EditableCell = ({
  value: initialValue,
  onChange,
  field,
  record,
  isFocused,
  setEditableField,
}) => {
  const [value, setValue] = useState(initialValue || "");
  const inputRef = useRef(null);

  useEffect(() => {
    // Only focus if the current field is the focused one
    if (isFocused) {
      inputRef.current?.focus();
    }
  }, [isFocused]);

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value); // Push change to parent
  };

  const handleFocus = () => {
    setEditableField(field); // Set which field is being edited
  };

  return (
    <input
      ref={inputRef}
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
      className="w-full p-1 text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] border-0 border-b border-gray-400 focus:outline-none"
    />
  );
};

export default EditableCell;

